import { enqueueToast } from '@/features/toasts/slice'
import { useAppDispatch } from '@/redux/hooks'
import { useSetMediaVerifiedMutation } from '../api'

export const useSetVerified = () => {
  const dispatch = useAppDispatch()
  const [trigger] = useSetMediaVerifiedMutation({
    fixedCacheKey: 'set-verified',
  })

  const setVerified = async (mediaCodes: number[]) => {
    try {
      await trigger(mediaCodes).unwrap()
      dispatch(
        enqueueToast({
          message: `Verified ${mediaCodes.length} media item(s).`,
          severity: 'success',
        }),
      )
    } catch (error) {
      console.error('Failed to verify media', error)
      dispatch(
        enqueueToast({
          message: 'Unable to verify media.',
          severity: 'error',
        }),
      )
    }
  }

  return { setVerified }
}
